/**
 * Class description
 *
 * Created: 2019-08-22
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {MysterySymbol} from "./parts/MysterySymbol";
import {Container, Sprite} from "pixi.js";
import {TimelineLite,TweenLite} from "gsap";
import {WinterHoardSoundConfig} from "../WinterHoardSoundConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SoundPlayer} from "../sound/SoundPlayer";

export class MysterySymbolRevealView extends BaseView {
    private _layer:ScalableLayer;
    private _reelContainer:Container;
    private _overlays:MysterySymbol[];
    private _introSprite:Sprite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(WinterHoardLayerConfig.MYSTERY_SYMBOL.name);
    }


    protected initAnimations():void {
        this._reelContainer = new PIXI.Container();
        //this._reelContainer.position.set(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y);
        this.addChild(this._reelContainer);
        this._layer.addChild(this);

        this._introSprite = new PIXI.Sprite(); //new Sprite(GameResources.getTextures(WinterHoardGameAssets.SHAMAN_INTRO)[0]);

        /**
                [0, 0]
         1: (2) [0, 1]
         2: (2) [0, 2]
         3: (2) [1, 0]
         4: (2) [1, 1]
         5: (2) [1, 2]
         6: (2) [2, 0]
         7: (2) [2, 1]
         8: (2) [2, 2]
         9: (2) [3, 0]
         10: (2) [3, 1]
         11: (2) [3, 2]
         12: (2) [4, 0]
         13: (2) [4, 1]
         14: (2) [4, 2]
         */
        const allPositions:[number, number][] = [
            [0, 0],
            [0, 1],
            [0, 2],
            [0, 3],

            [1, 0],
            [1, 1],
            [1, 2],
            [1, 3],

            [2, 0],
            [2, 1],
            [2, 2],
            [2, 3],

            [3, 0],
            [3, 1],
            [3, 2],
            [3, 3],

            [4, 0],
            [4, 1],
            [4, 2],
            [4, 3]
        ];

        //this.testOverlayPositions(allPositions, "L1");
    }

    public prepare(positions:[number, number][], revealedSymbol:string) {
        this.createOverlays(positions, revealedSymbol);
    }

    private testOverlayPositions(positions:[number, number][], revealedSymbol:string) {
        this._overlays = [];
        for(let i:number = 0; i < positions.length; i++) {
            const position = positions[i];
            this._overlays.push(new MysterySymbol(position, this._reelContainer, revealedSymbol));
        }

        this._overlays.forEach((sym:MysterySymbol) => {
            sym.showOverlay();
        });

    }

    private createOverlays(positions:[number, number][] = [], revealedSymbol:string = "") {
        this._overlays = [];
        for(let i:number = 0; i < positions.length; i++) {
            const position = positions[i];
            if(revealedSymbol !== "") {
                this._overlays.push(new MysterySymbol(position, this._reelContainer, revealedSymbol));
            }
        }
    }

    protected onResize(resizeData:IResizeData):void {

        //debugger;
        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this.scale.set(0.835, 0.835);


            // TODO: Needs to implement this to fit everything in 4:3
            if(resizeData.width >= 1280) {
                //this.scale.set(1, 1);
            } else {
                //this.scale.set(0.8, 0.8);
            }

            //this._overlays.forEach((mSymbol) => {
                //const position = Helper.getSymbolPositions(positions[i][0], positions[i][1]);
            //});

            this.x = 50; //GameConfig.instance.REEL_AREA_POS_X * 1.15;
            this.y = 0; //GameConfig.instance.REEL_AREA_POS_Y * 1.15 + 120;
        }
        else {
            this.scale.set(0.9, 0.9);
            this.x = 10; //GameConfig.instance.REEL_AREA_POS_X;
            this.y = 10; //GameConfig.instance.REEL_AREA_POS_Y;
        }

        /*this._reelViews.forEach((reelView:HarlequinReelView, reelId:number) => {
            const position = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
            reelView.updatePositions(position[0], position[1]);
        });*/

        //this._reelViews.forEach((reelView:Container, reelId:number) => {
        //this.updateReelViewPosition(reelView, reelId);
        //});
    }


    public getRevealAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(()=>SoundPlayer.playEffect(WinterHoardSoundConfig.MYSTERY_SYMBOL_REVEAL));

        for(let overlay of this._overlays) {
            tl.add(overlay.getRevealAnimation(), 0.1);
        }

        return tl;
    }


    public showOverlaysInReel(reelId:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        for(let overlay of this._overlays) {
            if (overlay.symbolPosition[0] == reelId){
                tl.add(overlay.getShowAnimation(false), 0);
            }
        }
        return tl;
    }


    public getShamanIntro():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        this._introSprite.alpha = 0;
        tl.add(() => {
            SoundPlayer.playEffect(WinterHoardSoundConfig.SHAMAN_TRIGGER);
            this.addChild(this._introSprite);
        });
        tl.add(new TweenLite(this._introSprite, 0.5, {alpha : 1}));
        tl.add(new TweenLite(this._introSprite, 0.5, {alpha : 0}), 1);

        tl.add(() => {
            this.removeChild(this._introSprite);
        });
        return tl;
    }

    public getShamanAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(this.getShamanIntro());

        const overlayAnimations:TimelineLite = new TimelineLite();
        for(let overlay of this._overlays) {
            overlayAnimations.add(overlay.getShowAnimation(true), 0);
        }
        tl.add([
            ()=>SoundPlayer.playEffect(WinterHoardSoundConfig.SHAMAN_SYMBOLS_APPEAR),
            overlayAnimations
        ]);

        return tl;
    }


}